import { FC } from "react";
import { useGetRelatedProductList } from "services/product";
import ProductList from "./ProductList";
import { IProductCard } from "types/product";

interface IRelatedProduct {
  mainProductId: number;
}
const RelatedProduct: FC<IRelatedProduct> = ({ mainProductId }) => {
  const { productList, isLoading } = useGetRelatedProductList(mainProductId);

  return (
    <div>
      <div className="font-semibold text-xl">สินค้าที่เกี่ยวข้อง</div>
      <div className="flex gap-4 overflow-x-scroll mt-4">
        <ProductList
          isLoading={isLoading}
          isList={false}
          data={productList as IProductCard[]}
        />
      </div>
    </div>
  );
};
export default RelatedProduct;
